"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgLaminate = function SvgLaminate(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    stroke: "#4A4A4A",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.192 2.778 4.243 4.243-1.414 1.414-4.243-4.243zm5.658 0 4.242 4.243-1.414 1.414-4.243-4.243zm5.656 0 4.243 4.243-1.414 1.414-4.243-4.243zm-8.486 0 4.243 4.243L9.85 8.435 5.607 4.192z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.678 2.778 4.242 4.243-1.414 1.414-4.243-4.243zm5.657 0 4.242 4.243-1.414 1.414-4.243-4.243zm-2.829 8.485 4.243 4.243-1.414 1.414-4.243-4.242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.335 11.263 4.242 4.243-1.414 1.414-4.243-4.242zm-5.657 0 4.242 4.243-1.414 1.414-4.243-4.242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.85 11.263 4.242 4.243-1.414 1.414-4.243-4.242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.02 11.263 4.243 4.243L9.85 16.92l-4.242-4.242zm-2.828 0 4.243 4.243-1.414 1.414-4.243-4.242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.607 7.02 7.02 8.436l-4.243 4.243-1.414-1.415zm5.656 0 1.415 1.415-4.243 4.243-1.414-1.415zm5.657 0 1.415 1.415-4.243 4.243-1.414-1.415z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.435 7.02 1.414 1.415-4.242 4.243-1.415-1.415zm5.657 0 1.414 1.415-4.243 4.243-1.414-1.415zm5.657 0 1.414 1.415-4.243 4.243-1.414-1.415zm0 8.486 1.414 1.414-4.243 4.243-1.414-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.92 15.506 1.415 1.414-4.243 4.243-1.414-1.414zm-2.828 0 1.414 1.414-4.243 4.243-1.414-1.414z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.263 15.506 1.415 1.414-4.243 4.243-1.414-1.414zm-2.828 0 1.414 1.414-4.242 4.243-1.415-1.414zm-3 0L6.85 16.92l-4.243 4.243-1.414-1.414z"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgLaminate);
var _default = exports["default"] = Memo;